module.exports = __webpack_public_path__ + "img/hr-pipe-t-up.09414009.png";